import Vue from "vue";
import moment from "moment";
import "../node_modules/moment/locale/pt-br";

export const userKey = "@ESIG_User";
// export const baseUrl = "http://localhost:8080";
// export const baseApiUrl = "http://esig-api.test:8070/api";
// export const baseStorageUrl = "http://esig-api.test:8070/storage/projetos";

export const baseUrl = "http://177.93.109.133";
export const baseApiUrl = baseUrl + "/api";
export const baseStorageUrl = baseUrl + "/storage/projetos";
export const baseStorageBIDUrl = baseUrl + "/storage/bid";

export function showError(e) {
  if (e && e.response && e.response.data && e.response.data.message) {
    Vue.toasted.global.defaultError({ msg: e.response.data.message });
  } else if (e && e.response && e.response.data && e.response.data.error) {
    Vue.toasted.global.defaultError({ msg: e.response.data.error });
  } else if (e && e.response && e.response.data) {
    let _error = JSON.parse(e.response.data);
    if (_error) {
      Vue.toasted.global.defaultError({ msg: _error.error });
    } else {
      Vue.toasted.global.defaultError({ msg: e.response.data });
    }
  } else if (typeof e === "string") {
    Vue.toasted.global.defaultError({ msg: e });
  } else {
    Vue.toasted.global.defaultError();
  }
}

export function validateDate(sDate, format) {
  return moment(sDate, [format], true).isValid();
}

export function formatDate(date, inputFormat, outputFormat, ltime = false) {
  if (inputFormat === "")
    return moment(date)
      .format(outputFormat)
      .substring(0, 10);
  else
    return moment(date, inputFormat)
      .format(outputFormat)
      .substring(0, ltime ? 10 : 1000);
}

export function validateCPF(strCPF) {
  let Resto;
  let Soma = 0;
  strCPF = strCPF.replace(/[^0-9]/g, "").toString();
  if (strCPF == "00000000000") return false;

  for (let i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(10, 11))) return false;
  return true;
}

export function validateCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj == "") return false;

  if (cnpj.length != 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
}

export function unFormatNumber(val) {
  if (val == null) return 0;

  if (val.indexOf(",") < 0) return parseFloat(_newVal);

  var _newVal = val.replace(/\./g, "").replace(",", ".");
  return parseFloat(_newVal);
}

export function formatMoney(number, places, symbol, thousand, decimal) {
  number = number || 0;
  places = !isNaN((places = Math.abs(places))) ? places : 2;
  symbol = symbol !== undefined ? symbol : "R$ ";
  thousand = thousand || ".";
  decimal = decimal || ",";
  var negative = number < 0 ? "-" : "",
    i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    symbol +
    negative +
    (j ? i.substr(0, j) + thousand : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) +
    (places
      ? decimal +
      Math.abs(number - i)
        .toFixed(places)
        .slice(2)
      : "")
  );
}

export function getColors(status) {
  if (status == 1) {
    return "#1EBC61"; // ativo
  } else if (status == 2) {
    return "#FFDA23"; // suspenso
  } else if (status == 3) {
    return "#2882BA"; // concluido
  } else if (status == 4) {
    return "#B72D32"; // atrasado
  } else {
    return "#000"; // indefinido
  }
}

export function getStatusTooltip(status) {
  if (status == 1) {
    return "Aberto"; // ativo
  } else if (status == 2) {
    return "Suspenso"; // suspenso
  } else if (status == 3) {
    return "Concluído"; // concluido
  } else if (status == 4) {
    return "Atrasado"; // atrasado
  } else {
    return "Indefinido"; // indefinido
  }
}

export const ganttOptions = {
  maxRows: 100,
  maxHeight: 300,
  title: {
    label: "Lista de Tarefas",
    html: false,
  },
  row: {
    height: 24,
  },
  scope: {
    before: 2,
    after: 2,
  },
  times: {
    timeZoom: 20,
    stepDuration: "day",
  },
  calendar: {
    hour: {
      display: false,
    },
    day: {
      height: 20, //*
      display: true, //*
      strokeWidth: 1,
      gap: 1,
      format: {
        long(date) {
          return date.format("DD ddd");
        },
        medium(date) {
          return date.format("DD ddd");
        },
        short(date) {
          return date.format("DD");
        },
      },
    },
  },
  chart: {
    progress: {
      bar: false,
    },
    text: {
      offset: 15, //*
      xPadding: 10, //*
      display: true, //*
    },
    expander: {
      type: "chart",
      display: false, //*
      displayIfTaskListHidden: true, //*
      offset: 0, //*
      size: 0,
    },
  },
  taskList: {
    expander: {
      straight: true,
    },
    columns: [
      {
        id: 1,
        label: "ID",
        //value: "id",
        value: (task) => {
          let _color = getColors(task.status);
          let _tooltip = getStatusTooltip(task.status);
          return `<div style='display: flex; align-items:center; justify-content: space-between; padding:5px; min-width:90px'><span>${task.id}</span> <i style='color:${_color}' title='${_tooltip}' class='fas fa-circle'></i></div>`;
        },
        width: 100,
        html: true,
      },
      {
        id: 2,
        label: "Descrição",
        value: "label",
        html: true,
        expander: true,
        width: 400,
      },
      {
        id: 3,
        label: "Início",
        value: (task) => moment(task.start).format("DD/MM/YYYY"),
        width: 78,
      },
      {
        id: 4,
        label: "Término",
        value: (task) => moment(task.end).format("DD/MM/YYYY"),
        width: 78,
      },
      {
        id: 5,
        label: "Duração",
        value: (task) => moment(task.end).diff(moment(task.start), "days"),
        width: 78,
      },
      {
        id: 6,
        label: "Predec.",
        value: (task) =>
          task.dependentOn.length == 0 ? "" : task.dependentOn.join(","),
        width: 78,
      },
      {
        id: 7,
        label: "Ações",
        html: true,
        value: (task) => {
          return (
            `<button class='btn btn-primary btn-xs ${task.id <= 0 ? "hidden" : ""
            }' onclick="doAlterarTarefa(${task.id
            })"><i class='fas fa-edit'></i></button>` +
            `<button class='btn btn-danger btn-xs ${task.id <= 0 ? "hidden" : ""
            }' onclick="doExcluirTarefa(${task.id
            })"><i class='fas fa-trash'></i></button>`
          );
        },
        width: 78,
      },
    ],
  },
  locale: {
    name: "pt-br",
    weekdays: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split(
      "_"
    ),
    weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
    weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),
    months: "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
      "_"
    ),
    monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
    ordinal: (n) => `${n}º`,
    formats: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [de] MMMM [de] YYYY",
      LLL: "D [de] MMMM [de] YYYY [às] HH:mm",
      LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm",
    },
    relativeTime: {
      future: "em %s",
      past: "há %s",
      s: "poucos segundos",
      m: "um minuto",
      mm: "%d minutos",
      h: "uma hora",
      hh: "%d horas",
      d: "um dia",
      dd: "%d dias",
      M: "um mês",
      MM: "%d meses",
      y: "um ano",
      yy: "%d anos",
    },
  },
};

export const ganttOptionsReadOnly = {
  maxRows: 100,
  maxHeight: 300,
  title: {
    label: "Lista de Tarefas",
    html: false,
  },
  row: {
    height: 24,
  },
  times: {
    stepDuration: "day",
  },
  calendar: {
    hour: {
      display: false,
    },
    day: {
      height: 20, //*
      display: true, //*
      format: {
        long(date) {
          return date.format("DD ddd");
        },
        medium(date) {
          return date.format("DD ddd");
        },
        short(date) {
          return date.format("DD");
        },
      },
    },
  },
  chart: {
    progress: {
      bar: false,
    },
    text: {
      offset: 15, //*
      xPadding: 10, //*
      display: true, //*
    },
    expander: {
      type: "chart",
      display: false, //*
      displayIfTaskListHidden: true, //*
      offset: 4, //*
      size: 18,
    },
  },
  taskList: {
    expander: {
      straight: true,
    },
    columns: [
      {
        id: 1,
        label: "ID",
        value: "id",
        width: 80,
      },
      {
        id: 2,
        label: "Descrição",
        value: "label",
        expander: true,
        width: 400,
      },
      {
        id: 3,
        label: "Início",
        value: (task) => moment(task.start).format("DD/MM/YYYY"),
        width: 78,
      },
      {
        id: 4,
        label: "Término",
        value: (task) => moment(task.end).format("DD/MM/YYYY"),
        width: 78,
      },
      {
        id: 5,
        label: "Predec.",
        value: (task) =>
          task.dependentOn.length == 0 ? "" : task.dependentOn.join(","),
        width: 78,
      },
    ],
  },
  locale: {
    name: "pt-br",
    weekdays: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split(
      "_"
    ),
    weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
    weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),
    months: "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
      "_"
    ),
    monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
    ordinal: (n) => `${n}º`,
    formats: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [de] MMMM [de] YYYY",
      LLL: "D [de] MMMM [de] YYYY [às] HH:mm",
      LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm",
    },
    relativeTime: {
      future: "em %s",
      past: "há %s",
      s: "poucos segundos",
      m: "um minuto",
      mm: "%d minutos",
      h: "uma hora",
      hh: "%d horas",
      d: "um dia",
      dd: "%d dias",
      M: "um mês",
      MM: "%d meses",
      y: "um ano",
      yy: "%d anos",
    },
  },
};

export default {
  baseStorageUrl,
  baseApiUrl,
  showError,
  userKey,
  formatDate,
  validateDate,
  validateCPF,
  validateCNPJ,
  unFormatNumber,
  formatMoney,
  ganttOptions,
  ganttOptionsReadOnly,
  getColors,
  getStatusTooltip,
};
